// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__14T7E","header":"Messages_header__2z5kq"};